// /* eslint-disable react-hooks/exhaustive-deps */
// // Core
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// // Styles
// import { CommonGlassContainer, Label } from "assets/styles/globalStyles";

// // Types
// import {
//     FounderWrapper,
//     ReadMoreButton
// } from "./styles";

// // Components
// import Loader from "components/Loader";

// // Others
// import { fetchData } from "utils/fetch";
// import { restAPIs } from "utils/restAPIs";
// import { useSelector } from "react-redux";
// import { useTranslation } from "react-i18next";
// import { motion } from "framer-motion";
// import { NewsMediaItem } from "pages/Homepage/styles";
// import { FontSizes, FontWeight } from "utils/enums";

// import AOS from "aos";
// import ArticleView from "pages/AwardList/ArticleView";
// import { Flex } from "antd";

// const Articles: React.FC = () => {
//     const { currentLang } = useSelector((store: any) => store.commonData);
//     const navigate = useNavigate();
//     const [isLoading, setLoading] = useState(false);
//     const { t } = useTranslation();
//     const [articles, setData] = useState<any[]>([]);
//     const [isOpenArticle, setOpenArticle] = useState(false)
//     const [article, setArticle] = useState<any>(null)
//     const [page, setPage] = useState(1)
//     const [isLastPage, setIsLastPage] = useState(false)


//     useEffect(() => {
//         AOS.init({
//             duration: 800, // Animation duration in milliseconds
//             easing: 'ease-in-out', // Easing function for the animation
//             once: false, // Ensures the animation runs every time the element is in view
//         });

//         const handleScroll = () => {
//             AOS.refresh();
//         };

//         window.addEventListener("scroll", handleScroll);
//         return () => {
//             window.removeEventListener("scroll", handleScroll);
//         };
//     }, []);


//     const fetchArticles = async () => {
//         setLoading(true);
//         const res = await fetchData(restAPIs.getArticles(currentLang?.id, page, 2));
//         setData(prevArticles => [...prevArticles, ...res.articles]);
//         setIsLastPage(res.isLastPage)
//         setLoading(false);
//     }

//     useEffect(() => {
//         fetchArticles()
//         window.scrollTo(0, 0);
//     }, [currentLang]);

//     const handleBook = (bookId: any) => {
//         navigate(`/book/${bookId}`)
//     }


//     const handleOpenArticle = (item: any) => {
//         setArticle(item)
//         setOpenArticle(true)
//     }



//     return (
//         <>
//             <FounderWrapper
//                 direction={(currentLang?.id) == 1 ? "rtl" : "ltr"}
//             >
//                 <div className="container">

//                     <div className="row justify-content-center">
//                         <div className="col-md-11">
//                             <CommonGlassContainer>
//                                 <motion.div
//                                     style={{ marginLeft: '-8px' }}
//                                     className='mb-5'
//                                     initial={{ opacity: 0, x: -50 }}
//                                     animate={{ opacity: 1, x: 0 }}
//                                     transition={{ duration: 0.5 }}
//                                 >
//                                     <Label className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={0} marginBottom={5}>{t('ibn_battuta_award')}</Label>
//                                 </motion.div>
//                                 <div className="row">
//                                 {
                                    
//                                         articles && articles.map((item: any, i: any) => {
//                                             return (

//                                                 <motion.div
//                                                     className='col-md-4 mb-3'
//                                                     initial={{ opacity: 0, y: 50 }}
//                                                     animate={{ opacity: 1, y: 0 }}
//                                                     transition={{ duration: 0.8, delay: 0.2 }}
//                                                     key={i}
//                                                     style={{ cursor: 'pointer' }}
//                                                     onClick={() => handleOpenArticle(item)}
//                                                     data-aos="fade-right"
//                                                     data-aos-delay={i * 200}
//                                                 >
//                                                     <NewsMediaItem>
//                                                         <img src={item.publicationIcon} alt="" 
//                                                             style={{
//                                                                 width: '100%',
//                                                                 height: '170px',
//                                                                 objectFit: 'cover',
//                                                             }}
//                                                         />
//                                                         <h1 title={item.name}>{item.name.length > 60 ? `${item.name.substring(0, 57)}...` : item.name}</h1>
//                                                         <p style={{
//                                                             minHeight: '80px',
//                                                             WebkitLineClamp: 4,
//                                                             display: '-webkit-box',
//                                                             WebkitBoxOrient: 'vertical',
//                                                             overflow: 'hidden',
//                                                         }}>{item.stripedBody}</p>
//                                                     </NewsMediaItem>
//                                                 </motion.div>
//                                             )
//                                         }
//                                         )
//                                 }
//                                 </div>
//                             </CommonGlassContainer>

//                             {isLoading && <Loader />}

//                             { !isLastPage && <div className="container">
//                                 <div className="row justify-content-center mb-5">
//                                     <Flex justify="center" className="mt-5">
//                                         <ReadMoreButton
//                                             onClick={() => {
//                                                 setPage(prevPage => prevPage + 1);
//                                                 fetchArticles();
//                                             }}
//                                             disabled={isLoading}
//                                         >
//                                             {t('more')}
//                                         </ReadMoreButton>
//                                     </Flex>
//                                 </div>
//                             </div>}
//                         </div>
//                     </div>
//                 </div>
//             </FounderWrapper>
//             <ArticleView
//                 open={isOpenArticle}
//                 onClose={() => setOpenArticle(false)}
//                 data={article}
//             />
//         </>
//     );
// };

// export default Articles;



/* eslint-disable react-hooks/exhaustive-deps */
// Core
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Styles
import { CommonGlassContainer, Label } from "assets/styles/globalStyles";

// Types
import {
    FounderWrapper,
    ReadMoreButton
} from "./styles";

// Components
import Loader from "components/Loader";

// Others
import { fetchData } from "utils/fetch";
import { restAPIs } from "utils/restAPIs";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { NewsMediaItem } from "pages/Homepage/styles";
import { FontSizes, FontWeight } from "utils/enums";
import AOS from "aos";
import ArticleView from "pages/AwardList/ArticleView";
import { Flex } from "antd";

const Articles: React.FC = () => {
    const { currentLang } = useSelector((store: any) => store.commonData);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [isLoading, setLoading] = useState(false);
    const [articles, setArticles] = useState<any[]>([]);
    const [isOpenArticle, setOpenArticle] = useState(false);
    const [article, setArticle] = useState<any>(null);
    const [page, setPage] = useState(1);
    const [isLastPage, setIsLastPage] = useState(false);

    // AOS Initialization
    useEffect(() => {
        AOS.init({ duration: 800, easing: 'ease-in-out', once: false });
        const handleScroll = () => AOS.refresh();
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // Fetch Articles when language or page changes
    useEffect(() => {
        const fetchArticles = async () => {
            setLoading(true);
            try {
                const res = await fetchData(restAPIs.getArticles(currentLang?.id, page, 2));
                setArticles(prev => page === 1 ? res.articles : [...prev, ...res.articles]);
                setIsLastPage(res.isLastPage);
            } catch (error) {
                console.error("Failed to fetch articles:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchArticles();
    }, [currentLang, page]);

    // Reset on language change
    useEffect(() => {
        setPage(1);
        setArticles([]);
        window.scrollTo(0, 0);
    }, [currentLang]);

    const handleOpenArticle = (item: any) => {
        setArticle(item);
        setOpenArticle(true);
    };

    return (
        <>
            <FounderWrapper direction={currentLang?.id === 1 ? "rtl" : "ltr"}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-11">
                            <CommonGlassContainer>
                                <motion.div
                                    className='mb-5'
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.5 }}
                                >
                                    <Label
                                        fontSize={FontSizes.h1}
                                        fontWeight={FontWeight.bold}
                                        marginTop={0}
                                        marginBottom={5}
                                    >
                                        {t('news_media')}
                                    </Label>
                                </motion.div>

                                <div className="row">
                                    {articles.map((item, i) => (
                                        <div
                                            key={i}
                                            className='col-md-4 mb-3'
                                            onClick={() => handleOpenArticle(item)}
                                            style={{ cursor: 'pointer' }}
                                            data-aos="fade-right"
                                            data-aos-delay={i * 200}
                                        >
                                            <NewsMediaItem>
                                                <img
                                                    src={item.publicationIcon}
                                                    alt=""
                                                    style={{
                                                        width: '100%',
                                                        height: '170px',
                                                        objectFit: 'cover',
                                                    }}
                                                />
                                                <h5>{new Date(item.creationdate).toLocaleDateString(currentLang?.id === 1 ? 'ar-SA' : 'en-US', {
                                                    day: '2-digit',
                                                    month: 'long',
                                                    year: 'numeric',
                                                })}</h5>
                                                <h1 title={item.name} style={{marginTop: '3px'}}>
                                                    {item.name.length > 60
                                                        ? `${item.name.substring(0, 57)}...`
                                                        : item.name}
                                                </h1>
                                                <p style={{
                                                    minHeight: '80px',
                                                    WebkitLineClamp: 4,
                                                    display: '-webkit-box',
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                }}>
                                                    {item.stripedBody}
                                                </p>
                                            </NewsMediaItem>
                                        </div>
                                    ))}
                                </div>
                            </CommonGlassContainer>

                            {isLoading && <Loader />}

                            {!isLastPage && !isLoading && (
                                <div className="container">
                                    <div className="row justify-content-center mb-5">
                                        <Flex justify="center" className="mt-5">
                                            <ReadMoreButton
                                                onClick={() => setPage(prev => prev + 1)}
                                                disabled={isLoading}
                                            >
                                                {t('more')}
                                            </ReadMoreButton>
                                        </Flex>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </FounderWrapper>

            <ArticleView
                open={isOpenArticle}
                onClose={() => setOpenArticle(false)}
                data={article}
            />
        </>
    );
};

export default Articles;
